<script>
import { updateProgressBar } from '../main';

export default {
  mounted() {
    updateProgressBar(this.$store);
  }
}
</script>
